import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { AddShuttleTransferInitStepDeclaration } from "./Steps/AddShuttleTransferInitStep";
import { AddShuttleTransferTransition } from "./Transition/AddShuttleTransferTransition";

export const addShuttleTransferStartupFlow = new FlowDefinition("AddShuttleTransferFlow");

addShuttleTransferStartupFlow.addStep(AddShuttleTransferInitStepDeclaration);
addShuttleTransferStartupFlow.addStep(checkoutStepDefinition);

addShuttleTransferStartupFlow.addLink("AddShuttleTransferInit_Step", "CheckoutFlow")

addShuttleTransferStartupFlow.addTransition(AddShuttleTransferTransition, "AddShuttleTransferInit_Step")

addShuttleTransferStartupFlow.setStartStep("AddShuttleTransferInit_Step");

export const addShuttleTransferStepDefinition = new StepDefinition({
    stepName: "AddShuttleTransferFlow",
    stepFlow: addShuttleTransferStartupFlow,
    contextIsolation: false
})
